import { CellContext, createColumnHelper } from '@tanstack/react-table'
import { UserGroup } from '../../types/GroupTypes'

export const policyGroupColumns = (
  checkedItems: Record<number, boolean>,
  setCheckedItems: (checkedItems: Record<number, boolean>) => void,
  handleCheckboxChange: (id: number) => void
) => {
  const columnHelper = createColumnHelper<UserGroup>()

  const columnHelpers = [
    {
      id: 'selection',
      cell: (row: CellContext<UserGroup, string>) => (
        <input
          key={row.row.original.id}
          id={'assigned_policy_' + row.row.original.id}
          type="checkbox"
          className={`h-8 w-8 text-blue-600 rounded focus:ring-mainPurple checked:bg-mainPurple dark:bg-transparent dark:checked:bg-mainPurple scale-50 cursor-pointer border-gray-800 dark:border-gray-200`}
          checked={checkedItems[row.row.original.id]}
          onChange={() => {
            setCheckedItems({
              ...checkedItems,
              [row.row.original.id]: !checkedItems[row.row.original.id],
            })
            handleCheckboxChange(row.row.original.id)
          }}
        />
      ),
    },
    columnHelper.accessor('name', {
      header: 'Group Name',
    }),
    columnHelper.accessor('memberCount', {
      header: 'Members',
    }),
    columnHelper.accessor('policyCount', {
      header: 'Policies',
    }),
  ]

  return columnHelpers
}
